export default __webpack_public_path__ + "images/1053951381db9b3f4ad6ba7753d24046.png";